import { render } from "./PauseInCircleIcon.vue?vue&type=template&id=36f3f12c"
import script from "./PauseInCircleIcon.vue?vue&type=script&lang=js"
export * from "./PauseInCircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__